const F1_EMOJIS = [
  "🏆", "🏎️", "🚀", "🔥", "💪", "⭐", "🎯", "👊", "🦁", "🐎",
  "💀", "❤️", "🍾", "🎉", "🏁", "🥇", "🌍", "💎", "🧠", "😈",
  "🇦🇺", "🇺🇸", "🇨🇦", "🇨🇴", "🇬🇧", "🇮🇹", "🇩🇪", "🇫🇷", "🇧🇷", "🇯🇵",
  "🌲", "🐻", "🦅", "🐺", "⚡", "🌶️", "👑", "🎲", "🔥", "🏁",
];

const uniqueEmojis = [...new Set(F1_EMOJIS)];

interface EmojiPickerProps {
  value: string;
  onChange: (emoji: string) => void;
}

const EmojiPicker = ({ value, onChange }: EmojiPickerProps) => (
  <div className="grid grid-cols-5 gap-1.5 max-h-[240px] overflow-y-auto p-2">
    {uniqueEmojis.map((emoji) => (
      <button
        key={emoji}
        type="button"
        onClick={() => onChange(emoji)}
        className={`flex h-10 w-full items-center justify-center rounded-md border-2 text-xl transition-all hover:scale-105 ${
          value === emoji
            ? "border-primary bg-primary/10 scale-105"
            : "border-transparent hover:border-muted-foreground/30"
        }`}
      >
        {emoji}
      </button>
    ))}
  </div>
);

export { EmojiPicker, F1_EMOJIS };
